module.exports = __webpack_public_path__ + "img/delete-hdtool.1e1dd9bc.png";